import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppDataService, MerchantService } from 'app/services';

@Component({
    selector: 'partner-business-info-update',
    templateUrl: './partner-business-info-update.component.html',
    styleUrls: ['./partner-business-info-update.component.scss']
})

export class PartnerBusinessInfoUpdateComponent {
    constructor(private messageService: MessageService,
        private appData: AppDataService,
        private merchantService: MerchantService) { }

    @Input()
    public visible: boolean = false;

    @Input()
    public onHide: () => void = () => { };

    public businessInfo: any = {};
    public loading: boolean = false;

    public cancel() {
        this.onHide();
    }

    public updateBusinessInfo() {
        const dto = {
            MerchantId: this.appData.authData.MerchantId,
            Name: this.businessInfo.name,
            BusinessName: this.businessInfo.businessName,
            Address: this.businessInfo.address,
            City: this.businessInfo.city,
            PostalCode: this.businessInfo.postalCode,
            Phone: this.businessInfo.phone,
            Email: this.businessInfo.email
        };

        this.merchantService.updateBusinessInfo(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }
}
